import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  requireAuth: boolean;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requireAuth, requireAdmin = false }) => {
  const { isAuthenticated, currentUser, loading } = useAuth();

  // If authentication is loading, show nothing
  if (loading) {
    return <div>Loading...</div>;
  }

  // If route requires authentication and user is not authenticated, redirect to login
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // If route requires admin and user is not admin, redirect to home
  if (requireAdmin && (!isAuthenticated || !currentUser?.is_admin)) {
    return <Navigate to="/" />;
  }

  // If route is for non-authenticated users only (like login page) and user is authenticated, redirect to home
  if (!requireAuth && isAuthenticated) {
    return <Navigate to="/" />;
  }

  // Otherwise, render the children
  return <Outlet />;
};

export default ProtectedRoute;
